import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { sendLog } from '../../../../utils';
import './recipe-styles.scss';

class RecipeRatings extends Component {
  constructor(props) {
    super(props);
    this.state = {
	    myRating: null,
      hoverRating: null,
    }
	  this.onSetRating = this.onSetRating.bind(this);
	  this.onStarHover = this.onStarHover.bind(this);
  }

  onSetRating(index) {
    const { id, slug } = this.props;
  	this.setState({
      myRating: index
    });
    // createCookie('recipeRatingCookie', '12/31/2069', index);
    const ratingKey  = `rating_${id}`;
    localStorage.setItem( `rating_${id}` , index);
    const postUrl = 'https://ratings-api.gallerymediagroup.net/add';
    const ratingObj = {
        "Type": "recipe",
        "Rating": index,
        "Id": id,
        "Slug": slug
    }
    let self = this;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', postUrl);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        self.getRating(id);

      }
      else if (xhr.status !== 200) {
        console.log(`Request failed.  Returned status of ${xhr.status}`);
        sendLog('Recipe Rating', "error", `Request failed.  Returned status of ${xhr.status}`);
      }
    };
    xhr.send(JSON.stringify(ratingObj));
  }

  onStarHover(index) {
    this.setState({
      hoverRating: index
    });
  }

  componentDidMount() {
    const { id } = this.props;
    const index = localStorage.getItem(`rating_${id}`);
    this.setState({
      myRating: index
    });
  }

  render() {
  	const { isMobile, } = this.props;
    const { hoverRating, myRating } = this.state;
    const starText = {
      1: "Didn't like it.",
      2: "Needs improvement.",
      3: "It's ok.",
      4: "I liked it.",
      5: "I loved it!"
    }

    const ratingsArray = [0, 0, 0, 0, 0];
    const renderedMyRatings = ratingsArray.map((star, i) => {
        const labelId = `rating${i+1}`;
        let labelClass = i < this.state.myRating ? "rating-label checked" : "rating-label"; 
          labelClass = i < this.state.hoverRating ? labelClass + " hovered" : labelClass;
      
        return (
          <Fragment>
            <input type="radio" id={labelId} onClick={() => this.onSetRating(i+1)} />
            <label className={labelClass} for={labelId} onMouseEnter={() => this.onStarHover(i+1)} onMouseLeave={() => this.onStarHover(null)}/>
          </Fragment>
        )
    });


    const myText = myRating ? starText[myRating] : "";
    const hoverText = hoverRating ? starText[hoverRating] : "";

    return (
      <Fragment>
        <div className="rating-wrapper my-rating-wrapper">
          <div className="rating-text">{this.state.myRating ? 'Your rating has been submitted!' : 'Made it? Rate it!'}</div>
          <fieldset id="my-rating" className="star-wrapper">
            {renderedMyRatings}
          </fieldset>
        </div>
        <div className="star-text">
            {hoverRating ? (
              hoverText
              ) : (
              myText
              )
            }
        </div>
      </Fragment>
    );
  }
}

export default RecipeRatings;